import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import apiCalls from '../utils/apiCalls';
import utils from '../utils/utils';
import {Link} from "react-router-dom";

class ItemViewMarketplaces extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      marketplaces: null,
      loading: true,
      errorMessage: null,
    };

    this.getContent = this.getContent.bind(this);
  }

  componentDidMount() {
    this.getMarketplaces();
  }

  getMarketplaces() {
    this.setState({
      loading: true,
      errorMessage: null,
    });

    apiCalls.getMarketplaces({
      itemId: this.props.item.id,
    }).then((result) => {
      if (result.data && result.data.marketplaces) {
        this.setState({
          marketplaces: result.data.marketplaces,
          loading: false,
        });
      }
    }).catch((errors) => {
      this.setState({
        errorMessage: utils.getErrorMessageFromResponse(errors),
        loading: false,
      });
    });
  }

  getContent() {
    if (!this.state.marketplaces) {
      return '';
    }

    const otherMarketplaces = this.props.marketplace?
      this.state.marketplaces.filter(marketplace => marketplace.id !== this.props.marketplace.id): this.state.marketplaces;

    const marketplaceLinks = otherMarketplaces.map((marketplace, index)=> (
      <div key={index}>
        <Link className="link" to={'/marketplaceAdmin/' + marketplace.id + '/view'}>
          <small>
            {marketplace.name}
          </small>
        </Link>
      </div>
    ));

    if (!this.props.marketplace && otherMarketplaces.length) {
      return (
        <React.Fragment>
          <div className="item-view__details-marketplaces-header text-primary text-uppercase">
            <small>
              <FormattedMessage id={'item.view.right.marketplaces.all.marketplaces.header'}/>
            </small>
          </div>

          {marketplaceLinks}
        </React.Fragment>
      );
    } else if (this.props.marketplace && otherMarketplaces.length) {
      return (
        <React.Fragment>
          <div className="item-view__details-marketplaces-header text-primary text-uppercase">
            <small>
              <FormattedMessage id={'item.view.right.marketplaces.other.marketplaces.header'}/>
            </small>
          </div>

          {marketplaceLinks}
        </React.Fragment>
      );
    } else if (!this.props.marketplace && otherMarketplaces.length === 0) {
      return (
        <React.Fragment>
          <div className="item-view__details-marketplaces-header text-primary text-uppercase">
            <small>
              <FormattedMessage id={'item.view.right.marketplaces.other.marketplaces.header'}/>
            </small>
          </div>
          <p>
            <FormattedMessage id={'item.view.right.marketplaces.no.marketplaces'}/>
          </p>
        </React.Fragment>
      );
    } else {
      return '';
    }
  }

  render() {
    const errorMessage = this.state.errorMessage? (
      <div className="row m-t-5 m-b-5">
        <div className="col-12">
          <div className="alert alert-error">
            {this.state.errorMessage}
          </div>
        </div>
      </div>
    ): '';

    const loader = this.state.loading? (
      <div className="m-t-5 m-b-5">
        <div className="b-loader"/>
      </div>
    ): '';

    const content = this.getContent();

    return (
      <div className="item-view__details-marketplaces m-b-6">
        {errorMessage}
        {loader}
        {content}
      </div>
    );
  }
}

ItemViewMarketplaces.propTypes = {
  item: PropTypes.object.isRequired,
  marketplace: PropTypes.object,
};

ItemViewMarketplaces.defaultProps = {};

export default ItemViewMarketplaces;
